import { Card, Col, Row, Typography } from "antd";

const { Text } = Typography;

export const DetailCard = ({ title, details }) => {
    return (
        <Card
            title={title}
            variant="borderless"
            className="w-full rounded-xl shadow-sm"
            styles={{
                body: {
                    padding: 0,
                },
            }}
        >
            <Row>
                {details.map((detail) => (
                    <Col
                        key={detail.label}
                        xs={24}
                        sm={12}
                        lg={8}
                        className="border-b border-slate-100 p-4"
                    >
                        <div className="flex flex-col gap-2">
                            <Text
                                type="secondary"
                                className="text-xs font-medium uppercase tracking-wide"
                            >
                                {detail.label}
                            </Text>

                            <div>
                                {detail.value}
                            </div>
                        </div>
                    </Col>
                ))}
            </Row>
        </Card>
    );
};
